import React from "react";

import "./stylesToggleSwitch.css";

function ToggleSwitch({
  status,
  eventCode,
  updateEventCode,
  onlyUpdate = false,
  data,
  disabled = false,
}) {
  const handleChangeStatus = (e) => {
    if (!onlyUpdate) {
      updateEventCode({ event_code: eventCode, is_active: e.target.checked });
      return;
    }
    updateEventCode(data);
  };

  return (
    <label className={`switch ${disabled ? "switch-disabled" : ""}`}>
      <input
        type="checkbox"
        checked={status}
        onChange={(e) => handleChangeStatus(e)}
        disabled={disabled}
      />
      <span className="slider round"></span>
    </label>
  );
}

export default ToggleSwitch;
